<template>
  <div class="loading-container" v-show="visible" @click.stop>
    <div class="icon"></div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  data(){
    return {
      visible: false
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-container {
  position: absolute;
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, .9);
  background-color: rgba(255, 255, 255, .5);
  font-size: 2rem;
  transition: .3s color, .3s border;
  box-sizing: border-box;
  .icon{
    display: inline-block;
    width: 1em;
    height: 1em;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    border: .2em solid transparent;
    border-top-color: currentcolor;
    border-radius: 50%;
    animation: 1s loader linear infinite;
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1em;
      height: 1em;
      position: absolute;
      top: -.2em;
      left: -.2em;
      border: .2em solid currentcolor;
      border-radius: 50%;
      opacity: .5;
      box-sizing: border-box;
    }
  }
}
@keyframes loader{
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>